import React, { FC } from 'react';
import { isEmpty, uniqueId } from 'lodash';
import { FieldArrayRenderProps, useFormikContext } from 'formik';
import { Button } from '@qbe/ads-core';
import { FormCard, Toggle } from '@qbe/ads-blocks-forms';
import { EmploymentData, EmploymentFormFields } from 'contexts/FormProvider';
import { YesNoList } from 'utils/constants';

import validationSchema from '../schema';
import FormSpacer from 'components/FormSpacer/FormSpacer';
import { useContentContext } from '@qbe/dfc-content';
import { useContentComplaintPartners } from 'utils/content';

interface Props {
  arrayHelpers: FieldArrayRenderProps;
}

const EmploymentStatus: FC<Props> = ({ arrayHelpers }) => {
  const { values, setFieldValue, setFieldTouched, resetForm } = useFormikContext<EmploymentFormFields>();

  const { getTextContent } = useContentComplaintPartners({
    context: useContentContext(),
  });

  const isDisabled = !validationSchema.isValidSync(values);

  const isCurrentlyEmployed = values.employmentStatus === 'yes';

  return (
    <FormCard variant="sectionTitle" title={getTextContent('fha.employment.details.section.heading')}>
      <Toggle
        title={getTextContent('fha.employment.details.employmentStatus')}
        required
        name="employmentStatus"
        optionList={YesNoList.map((option) => ({
          id: option.value,
          label: option.text,
          value: option.value,
          checked: values.employmentStatus === option.value,
          'data-track': 'employmentStatus',
          'data-track-value': 'capture',
          onBlur: () => setFieldTouched('employmentStatus', true),
          onChange: (event) => {
            const value = event.currentTarget.value;
            setFieldValue('employmentStatus', value);

            if (isEmpty(values.employmentData) && value === 'yes') {
              const newDetails: EmploymentData = {
                id: uniqueId(),
                employmentType: '',
                employerName: '',
                occupation: '',
                contactPerson: '',
                contactPersonNumber: '',
                salary: '',
              };

              arrayHelpers.push(newDetails);
            }

            if (!isEmpty(values.employmentData) && value === 'no') {
              resetForm({
                errors: {
                  employmentData: [],
                  employmentStatus: '',
                },
              });

              setFieldValue('employmentData', []);
              setFieldValue('employmentStatus', value);
            }
          },
        }))}
      />

      {!isCurrentlyEmployed && (
        <>
          <Button type="submit" label="Continue" disabled={isDisabled} />
        </>
      )}
    </FormCard>
  );
};

export default EmploymentStatus;
